export class EditIntegrationConstants {
  public static Name = {
    MinLength: 1,
    MaxLength: 64,
  };

  public static ApplicationId = {
    MaxLength: 64,
  };

  public static TenantId = {
    MaxLength: 64,
  };

  public static ClientSecret = {
    MaxLength: 64,
  };

  public static SecretAccessKey = {
    MaxLength: 64,
  };

  public static AccessKeyId = {
    MaxLength: 64,
  };

  public static Iss = {
    MaxLength: 256,
  };

  public static AdminApiKey = {
    MaxLength: 256,
  };

  public static AdminEmail = {
    MaxLength: 128,
  };

  public static Domain = {
    MaxLength: 128,
  };

  public static SubscriptionId = {
    MaxLength: 128,
  };

  public static OrganizationId = {
    MaxLength: 128,
  };

  public static HubName = {
    MaxLength: 256,
  };

  public static ConsumerGroup = {
    MaxLength: 256,
  };
}
